import React, { useState, useEffect } from 'react';
import { Minus, Plus, Trash2 } from 'lucide-react';

export default function CartItem({ item, onUpdateQuantity, onRemove }) {

  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (item?.quantity != null) {
      setInputValue(item.quantity.toString());
    }
  }, [item?.quantity]);

  if (!item || typeof item !== 'object') return null;

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setInputValue(value);
  };

  const commitQuantityChange = () => {
    const newQuantity = parseInt(inputValue, 10);

    if (isNaN(newQuantity) || newQuantity < 0) {
      setInputValue(item.quantity.toString());
    } else {
      onUpdateQuantity(item.id, newQuantity);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      commitQuantityChange();
      e.target.blur();
    }
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between p-4 bg-gray-50 rounded-xl gap-4">

      {/* Product Info */}
      <div className="flex items-center space-x-4 flex-grow w-full sm:w-auto">

        <img
          src={item.image}
          alt={item.name}
          className="w-24 h-24 rounded-lg object-cover shadow-sm"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://placehold.co/100x100/e2e8f0/a0aec0?text=Img';
          }}
        />

        <div className="flex-grow">
          <h3 className="text-lg font-semibold text-gray-800">{item.name}</h3>
        </div>

      </div>

      {/* Quantity Controls */}
      <div className="flex items-center space-x-2 sm:space-x-4">

        <div className="flex items-center border border-gray-300 rounded-lg">

          {/* Minus */}
          <button
            onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
            className="px-3 py-2 hover:bg-gray-200 rounded-l-lg transition-colors"
          >
            <Minus size={16} />
          </button>

          {/* Quantity Input (No Spinner) */}
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onBlur={commitQuantityChange}
            onKeyDown={handleKeyPress}
            className="w-14 text-center py-2 border-t border-b border-gray-300 focus:outline-none focus:ring-1 focus:ring-teal-500 sm:text-sm"
          />

          {/* Plus */}
          <button
            onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
            className="px-3 py-2 hover:bg-gray-200 rounded-r-lg transition-colors"
          >
            <Plus size={16} />
          </button>

        </div>

        {/* Remove */}
        <button
          onClick={() => onRemove(item.id)}
          className="text-red-500 hover:text-red-700 p-2 rounded-full hover:bg-red-100 transition-colors"
        >
          <Trash2 size={20} />
        </button>

      </div>

    </div>
  );
}
